import state from './moduleTalentState.js'
import mutations from './moduleTalentMutations.js'
import actions from './moduleTalentActions.js'
import getters from './moduleTalentGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}